import { BaseService } from "../../core/baseService";
import { NotificationSummaryDto } from "../types/notificationSummary.types";
import { ApiResult } from "../../core/types";

export interface NotificationServiceInterface {
  getSummary(): Promise<ApiResult<NotificationSummaryDto>>;
}

export class NotificationService
  extends BaseService
  implements NotificationServiceInterface
{
  async getSummary(): Promise<ApiResult<NotificationSummaryDto>> {
    return this.handleRequest<NotificationSummaryDto>(
      this.client.get("/api/admin/notifications/summary"),
    );
  }
}
